var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topTab',{on:{"handleTab":_vm.scrollToElement}}),_vm._v(" "),_c('Banner'),_vm._v(" "),_c('Advantages',{ref:"scroll0"}),_vm._v(" "),_c('HowToApply',{ref:"scroll1"}),_vm._v(" "),_c('Evaluate'),_vm._v(" "),_c('Company',{ref:"scroll2"}),_vm._v(" "),_c('RepaymentMethods'),_vm._v(" "),_c('FQ',{ref:"scroll3"}),_vm._v(" "),_c('PrivacyPolicy',{ref:"scroll4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/index.vue?vue&type=template&id=2d75d2a0&scoped=true
// module id = null
// module chunks = 